import { useQuery } from '@tanstack/react-query';
import { RequestsKey } from './types';
import { requestsRepo } from '@/constants/providers';
import { OrganizationContext } from '@/components/OrganizationProvider/OrganizationProvider';
import { useContext } from 'react';

export const useGetRequestTotals = (onlyActiveRequests: boolean) => {
  const { organizationId } = useContext(OrganizationContext);
  return useQuery({
    queryKey: [...RequestsKey.TOTALS(onlyActiveRequests), organizationId],
    queryFn: () => {
      return requestsRepo.getTotals(onlyActiveRequests);
    },
  });
};
